/**
 * KAN-783: карточка "Что выяснил бот" в карточке клиента: настроенные
 * атрибуты лида и их значения (пустое: прочерк). Нет атрибутов: ничего.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ClientLeadAttribute } from '@/types/client';

const EMPTY_VALUE = '-';

export function LeadAttributesCard({ attributes }: { attributes?: ClientLeadAttribute[] }) {
  if (!attributes || attributes.length === 0) return null;
  return (
    <Card data-testid="client-lead-attributes">
      <CardHeader>
        <CardTitle className="text-base">Что выяснил бот</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {attributes.map((attribute) => (
          <div key={attribute.id} className="flex items-start justify-between gap-2 text-sm" data-testid="client-lead-attribute">
            <span className="text-gray-500">{attribute.name}</span>
            <span className={`text-right break-words ${attribute.value ? '' : 'text-gray-400'}`}>
              {attribute.value?.trim() ? attribute.value : EMPTY_VALUE}
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
